import { render, staticRenderFns } from "./WindControlInfo.vue?vue&type=template&id=4afacdda&"
import script from "./WindControlInfo.vue?vue&type=script&lang=js&"
export * from "./WindControlInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports